// extracted by mini-css-extract-plugin
export default {"controls":"styles_controls__T46pN","open_controls":"styles_open_controls__e8JFn"};